import AddProductModal from "../../components/ui/AddProductModal";
import ProductCard from "../products/ProductCard";
import Loading from "../../components/ui/Loading";
import { useFetchProducts } from "../../hooks/products/useFetchProducts";
import { Product, SubCategory } from "../../types/products";
import { useState } from "react";

const InventoryCatalog = ({
  handleSelectProduct,
  onProductCreated,
}: {
  handleSelectProduct: (product: Product) => void;
  onProductCreated: (product: Product) => void;
}) => {
  const { data: products, isLoading, isError } = useFetchProducts();
  const [searchName, setSearchName] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("all");

  console.log(products, 'product list');

  if (isLoading) return <Loading />;
  if (isError)
    return <div>Failed to Fetch Inventory, Please try again later.</div>;

  const filteredProducts = (Array.isArray(products) ? products : []).filter(
    (product: Product) => {
      const matchesName = product.name
        .toLowerCase()
        .includes(searchName.toLowerCase());
      const matchesSubCategory =
        selectedSubCategory === "all" ||
        product.sub_category === selectedSubCategory;
      return matchesName && matchesSubCategory;
    },
  );

  return (
    <div className="space-y-6 animate-in slide-in-from-right-4 duration-300">
      <div className="flex justify-between items-center bg-white p-4 rounded-2xl shadow-sm border border-slate-100">
        <h3 className="font-bold text-slate-700">Supplement Catalog</h3>
        <AddProductModal onProductCreated={onProductCreated}>
          <button className="bg-emerald-600 text-white px-6 py-2.5 rounded-xl font-bold hover:bg-emerald-700 transition-all active:scale-95">
            Add Product
          </button>
        </AddProductModal>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 bg-white p-4 rounded-2xl shadow-sm border border-slate-100">
        {/* Name search */}
        <div className="relative flex-1">
          <svg
            className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-4 h-4 pointer-events-none"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
            />
          </svg>
          <input
            type="text"
            placeholder="Search by name..."
            value={searchName}
            onChange={(e) => setSearchName(e.target.value)}
            className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-slate-200 text-slate-700 placeholder-slate-400 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all"
          />
        </div>

        {/* Sub-category filter */}
        <select
          value={selectedSubCategory}
          onChange={(e) => setSelectedSubCategory(e.target.value)}
          className="sm:w-52 px-4 py-2.5 rounded-xl border border-slate-200 text-slate-700 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-transparent transition-all appearance-none cursor-pointer"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2394a3b8' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E")`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right 0.75rem center",
            backgroundSize: "1rem",
            paddingRight: "2.5rem",
          }}
        >
          <option value="all">All Sub-categories</option>
          {SubCategory.map((cat) => (
            <option key={cat} value={cat}>
              {cat}
            </option>
          ))}
        </select>

        {/* Clear — only shown when a filter is active */}
        {(searchName || selectedSubCategory !== "all") && (
          <button
            onClick={() => {
              setSearchName("");
              setSelectedSubCategory("all");
            }}
            className="sm:w-auto px-4 py-2.5 rounded-xl border border-slate-200 text-slate-500 text-sm hover:bg-slate-50 hover:text-slate-700 transition-all active:scale-95 whitespace-nowrap"
          >
            Clear
          </button>
        )}
      </div>

      {filteredProducts.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-16 text-slate-400 bg-white rounded-2xl border border-slate-100">
          <svg
            className="w-10 h-10 mb-3 text-slate-300"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z"
            />
          </svg>
          <p className="text-sm font-medium">No products match your filters</p>
          <p className="text-xs mt-1">Try a different name or category</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-6">
          {filteredProducts.map((product) => (
            <ProductCard
              product={product}
              key={product.id}
              onSelect={handleSelectProduct}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default InventoryCatalog;
